module.exports = __webpack_public_path__ + "static/media/icon-contact-sign.1036dfae.svg";